const getters = {
    active: state => state.navbar.active,
    parentId: state => state.file.parentId === '-1' ? state.file.defaultParentId : state.file.parentId,
    defaultParentId: state => state.file.defaultParentId,
    defaultParentFilename: state => state.file.defaultParentFilename,
    fileList: state => state.file.fileList,
    multipleSelection: state => state.file.multipleSelection,
    fileTypes: state => state.file.fileTypes,
    breadCrumbs: state => state.breadcrumb.breadCrumbs,
    searchFlag: state => state.file.searchFlag,
    wechatNickName: state => state.user.wechatNickName,
    cacheSearchKey: state => state.file.searchKey,
    tableLoading: state => state.file.tableLoading,
    uploadTaskFlag: state => state.task.taskList.length <= 0,
    uploadTaskNum: state => state.task.taskList.length,
    uploadTaskList: state => state.task.taskList,
    taskListViewFlag: state => state.task.viewFlag,
    userInfo: state => state.user.userInfo,
    usedMemory: state => state.user.usedMemory,
    memoryCapacity: state => state.user.memoryCapacity,
    balanceCapacity: state => state.user.balanceCapacity,
    getUploadTask: state => (fileName) => {
        return state.task.taskList.find(taskItem => fileName === taskItem.fileName)
    }
}

export default getters